import styled from "styled-components";

const ProductLink = styled.div`
  text-decoration: none !important;
  color: #222;
  cursor: pointer;

  &:hover {
    color: #222;
  }
`;
export default ProductLink;
